/* ============================================================
   PehroDesign storefront behaviour.
   Vanilla, no dependencies, no build step.
   Runs on every page; each block is a no-op if its markup
   is not present, so it is safe to load globally.
   ============================================================ */
(function () {
  'use strict';

  /* Sections each reference this file, so guard against a second init
     double-binding every listener. */
  if (window.__PEHRO_INIT__) return;
  window.__PEHRO_INIT__ = true;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function init() {
    /* ---------- PDP gallery dots ---------- */
    document.querySelectorAll('.ph-gal').forEach(function (gal) {
      var dots = gal.parentNode.querySelector('.ph-dots');
      if (!dots) return;
      gal.addEventListener('scroll', function () {
        var i = Math.round(gal.scrollLeft / gal.clientWidth),
          k = dots.children;
        for (var j = 0; j < k.length; j++) k[j].classList.toggle('is-on', j === i);
      }, { passive: true });
    });

    /* ---------- colour swatch dot follows the colour select ---------- */
    document.querySelectorAll('.ph-sel--sw').forEach(function (wrap) {
      var sel = wrap.querySelector('select'),
        dot = wrap.querySelector('.ph-sel__dot');
      if (!sel || !dot) return;
      function paint() {
        var o = sel.options[sel.selectedIndex];
        if (!o) return;
        var hex = o.getAttribute('data-hex'),
          img = o.getAttribute('data-img');
        dot.style.backgroundImage = img ? 'url(' + img + ')' : 'none';
        dot.style.background = img ? '' : (hex || 'transparent');
        if (img) dot.style.backgroundImage = 'url(' + img + ')';
      }
      sel.addEventListener('change', paint);
      paint();
    });

    /* ---------- variant matching ----------
       Two option selects drive a hidden variant id. Variant data is
       emitted by the product section as a compact array, so we never
       ship the full 250-variant product JSON. */
    document.querySelectorAll('[data-ph-product]').forEach(function (root) {
      var dataEl = root.querySelector('[data-ph-variants]');
      if (!dataEl) return;

      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

      var idInput = root.querySelector('[data-ph-variant-id]'),
        addBtn = root.querySelector('[data-ph-add]'),
        priceEl = root.querySelector('[data-ph-price]'),
        stickyPrice = document.querySelector('[data-ph-sticky-price]'),
        selects = Array.prototype.slice.call(root.querySelectorAll('[data-ph-option]')),
        moneyFormat = root.getAttribute('data-money') || '${{amount}}';

      function money(cents) {
        var n = (cents / 100).toFixed(2);
        return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, n)
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
          .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, n.replace('.', ','));
      }

      function chosen() {
        return selects.map(function (s) { return s.value; });
      }

      function findVariant() {
        var want = chosen();
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i], ok = true;
          for (var j = 0; j < want.length; j++) {
            if (v.o[j] !== want[j]) { ok = false; break; }
          }
          if (ok) return v;
        }
        return null;
      }

      function update() {
        var v = findVariant();

        /* "My own measurements" is a service route, not a variant:
           send the buyer to the custom order page instead of the cart. */
        var custom = chosen().indexOf(window.PEHRO_CUSTOM_SIZE_LABEL || 'My own measurements') > -1;
        if (custom) {
          if (addBtn) {
            addBtn.disabled = false;
            addBtn.textContent = addBtn.getAttribute('data-label-custom') || 'Send my measurements';
            addBtn.setAttribute('data-mode', 'custom');
          }
          return;
        }
        if (addBtn) {
          addBtn.removeAttribute('data-mode');
          addBtn.textContent = addBtn.getAttribute('data-label-add') || 'Add to bag';
        }

        if (!v) {
          if (addBtn) { addBtn.disabled = true; addBtn.textContent = addBtn.getAttribute('data-label-none') || 'Unavailable'; }
          return;
        }
        if (idInput) idInput.value = v.id;
        if (addBtn) addBtn.disabled = !v.a;
        if (addBtn && !v.a) addBtn.textContent = addBtn.getAttribute('data-label-sold') || 'Sold out';
        if (priceEl) priceEl.innerHTML = money(v.p);
        if (stickyPrice) stickyPrice.innerHTML = money(v.p);

        if (window.history && window.history.replaceState) {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', u.toString());
        }
      }

      selects.forEach(function (s) { s.addEventListener('change', update); });
      update();

      if (addBtn) {
        addBtn.addEventListener('click', function (e) {
          if (addBtn.getAttribute('data-mode') === 'custom') {
            e.preventDefault();
            var to = root.getAttribute('data-custom-url');
            if (to) window.location.href = to;
          }
        });
      }
    });

    /* ---------- sticky add to bag, shown once the main button scrolls away ---------- */
    var sticky = document.querySelector('.ph-sticky'),
      anchor = document.querySelector('[data-ph-buy-anchor]');
    if (sticky && anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        sticky.classList.toggle('is-on', !entries[0].isIntersecting);
      }, { rootMargin: '0px 0px -60px 0px' }).observe(anchor);
    }

    /* ---------- size guide popup ---------- */
    var sheet = document.querySelector('[data-ph-sizeguide]');
    if (sheet) {
      var lastTrigger = null;

      function show(which) {
        sheet.querySelectorAll('.ph-sg').forEach(function (p) {
          p.classList.toggle('is-on', p.getAttribute('data-sg') === which);
        });
        sheet.querySelectorAll('input[data-sg]').forEach(function (i) {
          i.checked = i.getAttribute('data-sg') === which;
        });
      }
      function open(which, trigger) {
        lastTrigger = trigger || null;
        show(which);
        sheet.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        var close = sheet.querySelector('[data-ph-close]');
        if (close) close.focus();
      }
      function close() {
        if (!sheet.classList.contains('is-open')) return;
        sheet.classList.remove('is-open');
        document.body.style.overflow = '';
        if (lastTrigger) lastTrigger.focus();
      }

      document.querySelectorAll('[data-ph-open-sizeguide]').forEach(function (b) {
        b.addEventListener('click', function () {
          open(b.getAttribute('data-ph-open-sizeguide'), b);
        });
      });
      sheet.addEventListener('click', function (e) {
        if (e.target.closest('[data-ph-close]')) close();
      });
      sheet.addEventListener('change', function (e) {
        var i = e.target.closest('input[data-sg]');
        if (i) show(i.getAttribute('data-sg'));
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') close();
      });
    }

    /* ---------- collection sort ---------- */
    var sort = document.querySelector('[data-ph-sort]');
    if (sort) {
      sort.addEventListener('change', function () {
        var u = new URL(window.location.href);
        u.searchParams.set('sort_by', sort.value);
        u.searchParams.delete('page');
        window.location.href = u.toString();
      });
    }
  }

  ready(init);
})();
